<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipocond">
    <fieldset id="agregar_tiposol" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>

                    <div class="form-horizontal titulo">
                        <div class="form-group" align="left">
                            <div class="col-md-8">
                                <label for="tipo_sol" *ngIf="n_form != '5.6'">Tipo de condominio: </label>
                                <label for="tipo_sol" *ngIf="n_form == '5.6'">Construcciones o Proyectos con construcciones destinadas a condominio tipo:</label>
                            </div>
                            <div class="col-sm-3" class="inline" style="font-size: 13px">
                                <div class="col-md-1">
                                    <mat-checkbox (change)="add_tipo_condominio()" [(ngModel)]="condominio['A']" name="condominio" value="1">A</mat-checkbox>
                                </div>
                                <div class="col-md-1">
                                    <mat-checkbox (change)="add_tipo_condominio()" [(ngModel)]="condominio['B']" name="condominio" value="2">B</mat-checkbox>
                                </div>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                    </div>

                    <br>
                </div>

            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>